var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.375H5.625V8.625H4.375V7.375ZM4.375 9.875H5.625V11.125H4.375V9.875ZM6.875 7.375H8.125V8.625H6.875V7.375ZM6.875 9.875H8.125V11.125H6.875V9.875ZM9.375 7.375H10.625V8.625H9.375V7.375ZM9.375 9.875H10.625V11.125H9.375V9.875Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 14.25H11.875C12.5644 14.25 13.125 13.6894 13.125 13V4.25C13.125 3.56062 12.5644 3 11.875 3H10.625V1.75H9.375V3H5.625V1.75H4.375V3H3.125C2.43562 3 1.875 3.56062 1.875 4.25V13C1.875 13.6894 2.43562 14.25 3.125 14.25ZM11.875 5.5L11.8756 13H3.125V5.5H11.875Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendars);
export default __webpack_public_path__ + "static/media/calendars.ccc319c47009fef14cf4203b2fe0b01a.svg";
export { ForwardRef as ReactComponent };